import React from 'react';

import { CloudinaryVideo } from '../../cloudinary-resources/CloudinaryVideo';
import { Video } from '../domain/Video';

interface GalleryVideoProps {
  video: Video;
  tenant: string;
  playerId: string;
}

export const GalleryVideo: React.FC<GalleryVideoProps> = (props) => {
  return (
    <CloudinaryVideo
      publicId={props.video.id}
      cloudinaryUrl={props.video.cloudinaryUrl}
      playerId={props.playerId}
      tenant={props.tenant}
      videoConfig={{
        playsInline: true,
        preload: 'none',
        transformation: {
          aspectRatio: '1:1',
          crop: 'fill',
          width: '700',
          height: '700',
          gravity: 'auto',
          transformation: {
            dpr: 'auto',
            quality: 'auto',
            format: 'auto',
          },
        },
        autoplay: props.video.autoplay,
        loop: props.video.loop,
        muted: props.video.autoplay,
      }}
      posterUrl={props.video.posterImage}
      altText={props.video.videoAlt}
    />
  );
};
